import { createContext, useContext, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLocalStorage } from "./UseLocalStorage";
import { ReactNode } from "react";
import { Session, User } from "@supabase/supabase-js";
import { Remember } from "../Model/Remember";

const AuthContext = createContext<{
  user: User | null;
  session: Session | null;
  remember: Remember | null;
  login: (data: any, check: boolean) => void;
  logout: (check: boolean) => void;
  }>({
    user: null,
    session: null,
    remember: null,
    login: (data: any, check: boolean) => {},
    logout: (check: boolean) => {},
  });

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useLocalStorage<User | null>("user", null);
  const [session, setSession] = useLocalStorage<Session | null>("session", null);
  const [remember, setRemember] = useLocalStorage<Remember | null>("remember", null);
  const navigate = useNavigate();
  const location = useLocation();

  // call this function when you want to authenticate the user
  const login = async (data: any, check: boolean) => {
    setUser(data.user);
    setSession(data.session);
    setRemember({ email: data.user.email, check });
    const from = "/feed";
    navigate(from, { replace: true });
  };

  // call this function to sign out logged in user
  const logout = (check: boolean) => {
    setUser(null);
    setSession(null);
    if (!check) {
      setRemember(null);
    }
    navigate("/login", { replace: true });
  };


  const value = useMemo(
    () => ({
      user,
      session,
      remember,
      login,
      logout,
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
